(function ($) {
  var elementorHookRegistered = false;
  var aosInitialized = false;

  function refreshAos() {
    if (!window.AOS) {
      return;
    }

    if (!aosInitialized) {
      window.AOS.init();
      aosInitialized = true;
      return;
    }

    if (typeof window.AOS.refreshHard === 'function') {
      window.AOS.refreshHard();
    } else if (typeof window.AOS.refresh === 'function') {
      window.AOS.refresh();
    }
  }

  function registerElementorHook() {
    if (
      elementorHookRegistered ||
      !window.elementorFrontend ||
      !window.elementorFrontend.hooks
    ) {
      return;
    }

    elementorHookRegistered = true;

    ['hero-slider', 'info-cards'].forEach(function (widgetName) {
      window.elementorFrontend.hooks.addAction(
        'frontend/element_ready/' + widgetName + '.default',
        refreshAos
      );
    });
  }

  $(window).on('elementor/frontend/init', registerElementorHook);

  $(function () {
    registerElementorHook();
    refreshAos();
  });
})(jQuery);
